import React, { useRef, useEffect, useMemo } from 'react';
import { Points, PointMaterial } from '@react-three/drei';
import * as THREE from 'three';
import { useSceneState } from '../providers/SceneProvider';
import { useCache } from '../../application/hooks/useCache';
import { CONFIG } from '../../index';

export function PointCloud() {
  const { currentFrame, currentFrameId } = useSceneState();
  const { getColorBuffer } = useCache();

  const geometry = useMemo(() => {
    if (!currentFrame) return null;

    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.Float32BufferAttribute(currentFrame.pointCloud.positions, 3));

    const colors = getColorBuffer(currentFrameId);
    if (colors) {
      geo.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    }

    return geo;
  }, [currentFrame, currentFrameId, getColorBuffer]);

  useEffect(() => {
    return () => {
      geometry?.dispose();
    };
  }, [geometry]);

  if (!geometry) return null;

  return (
    <points geometry={geometry}>
      <pointsMaterial
        vertexColors
        size={CONFIG.pointSize}
        sizeAttenuation
        depthWrite={false}
      />
    </points>
  );
}
